import { FormItem } from "./FormItem";
import { Textarea } from "../Textarea";
import { Input } from "../Input";
import { Tag } from "../../Tag";

export class Text extends FormItem {

    public getType() {
        return "Text";
    }

    public getValue() {
        const tag = this.getITag();
        return tag.getStripText();
    }

    protected initialize(data: any) {
        super.initialize(data);
        let t: HTMLElement = null;
        if (this.getTag()) {
            t = (this.getTag() as any).findByTag("input") || (this.getTag() as any).findByTag("textarea");
            // Phase contrôle sur un contrôle substitué in place : la racine EST
            // l'input (pas de wrapper), findByTag ne cherche que les descendants.
            const rootEl = (this.getTag() as any).getElement && (this.getTag() as any).getElement();
            if (!t && rootEl && (rootEl.tagName === "INPUT" || rootEl.tagName === "TEXTAREA")) {
                t = rootEl;
            }
        } else {
            t = this.findByTag("input") || this.findByTag("textarea");
        }

        this.addToData("itag", this.get("textarea") ? new Textarea(t) : new Input(t));

        if (this.get("textarea")) {
            const t: Tag = this.getITag();

            const listenerF = () => {
                if (this.has("remL")) {
                    return;
                }
                t.fixHeight();
                t.focus();
                this.addToData("remL", true);
            };
            this.addListener("input", listenerF);

            t.fixHeight();
            t.focus();
        }
    }

    protected createSelf(): void {

        let input: any = null,
            val = this.trans("value");

        const attrs = [
            {n: "ft", v: "txtl"},
            {n: "type", v: this.get("it") || "text"},
            {n: "contenteditable", v: true},
        ];
        if (this.get("autocomplete")) { attrs.push({n: "autocomplete", v: this.get("autocomplete")}); }
        if (this.get("readonly"))     { attrs.push({n: "readonly", v: true}); }
        if (this.get("it") !== "date" && this.get("it") !== "datetime-local") {
            attrs.push({n: "placeholder", v: this.get("ph") || this.get("placeholder") || this.trans("label")});
        } else if (this.get("it") !== "datetime-local") {
            if (val) {
                const date = new Date(val);
                val = date.toJSON().slice(0, 10);
            }
        } else {
            attrs.push({n: "min", v: this.trans("dtmin")});
        }
        if (val !== undefined && val !== null) { attrs.push({n: "value", v: val}); }

        const iclass = this.get("iclass");
        if (this.get("ft") === "txtl") {
            input = {
                attributes: attrs,
                class: iclass ? "textlinebox " + iclass : "textlinebox",
                t: "input",
                it: this.get("it"),
            };
        } else {
            input = {
                attributes: [
                    {n: "ft", v: "txt"},
                    {n: "contenteditable", v: true},
                    {n: "placeholder", v: this.get("ph") || this.trans("label")},
                    {n: "value", v: this.trans("value")},
                ],
                class: iclass ? "textbox " + iclass : "textbox",
                t: "textarea",
                v: this.trans("value"),
            };
        }

        const c = this.createItemTag(input);

        this.setElement(c.getElement());
    }
}
